var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "international",
      staticStyle: { display: "flex", "align-items": "center" },
      attrs: { trigger: "click" },
      on: { command: _vm.handleSetLanguage },
    },
    [
      _c(
        "div",
        [
          _c("svg-icon", {
            staticStyle: { color: "var(--TextPrimary)" },
            attrs: {
              "class-name": "international-icon",
              "icon-class": "language",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "zh_CN", command: "zh_CN" } },
            [_vm._v("\n      简体中文\n    ")]
          ),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "zh_TW", command: "zh_TW" } },
            [_vm._v("\n      繁体中文\n    ")]
          ),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "en_US", command: "en_US" } },
            [_vm._v("\n      English\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }